import { apiClient } from './api';

export interface CashFlowManagementData {
  id?: number;
  year: number;
  annualSalaryData: {
    employees: Array<{
      id: number;
      name: string;
      monthlyCosts: number[];
    }>;
  };
  // Cash Flow 페이지 전용 추가 직원
  cfAdditionalEmployees?: Array<{
    id?: string;
    name: string;
    monthlyCosts: number[];
  }>;
  // 새로운 전용 컬럼들
  summerBonusWelfare?: number[];
  projectExpense?: number[];
  tAndEExpense?: number[];
  outSourcingRestructuring?: number[];
  // 기존 editableData는 기말현금/기초현금만 남김
  editableData: {
    endingCash: number[];
    beginningCash: number[];
  };
  researchItems?: {
    fixedItems: {
      researchConsulting: number[];
      croGrants: number[];
      bpoManuscription: number[];
    };
    displayLabels?: {
      researchConsulting?: string;
      croGrants?: string;
      bpoManuscription?: string;
    };
    additionalItems: Array<{
      label: string;
      values: number[];
    }>;
  };
  consultingDynamicProjects?: {
    [projectName: string]: number[]; // PPE 프로젝트명을 키로 하고, 월별 매출 배열을 값으로 하는 동적 객체
  };
  opexData: {
    indirectOpex: number[];
    directOpex: number[];
  };
  calculatedTotals: {
    monthlyTotals: number[];
    cumulativeTotals: number[];
  };
}

export const cashFlowManagementApi = {
  getByYear: (year: number): Promise<CashFlowManagementData[]> => {
    return apiClient.get<CashFlowManagementData[]>(`/cash-flow-management/year/${year}`);
  },

  update: (id: number, data: Partial<CashFlowManagementData>): Promise<CashFlowManagementData> => {
    return apiClient.patch<CashFlowManagementData>(`/cash-flow-management/${id}`, data);
  },

  updateByYear: (year: number, data: Partial<CashFlowManagementData>): Promise<CashFlowManagementData> => {
    return apiClient.patch<CashFlowManagementData>(`/cash-flow-management/year/${year}`, data);
  },

  // Cash Flow 전용 추가 직원 관리 API
  addCfEmployee: (year: number, name: string, monthlyCosts: number[]): Promise<CashFlowManagementData> => {
    return apiClient.post<CashFlowManagementData>(`/cash-flow-management/year/${year}/cf-employees`, {
      name,
      monthlyCosts
    });
  },

  updateCfEmployee: (year: number, indexOrId: number | string, data: { name?: string; monthlyCosts?: number[] }): Promise<CashFlowManagementData> => {
    return apiClient.patch<CashFlowManagementData>(`/cash-flow-management/year/${year}/cf-employees/${indexOrId}`, data);
  },

  removeCfEmployee: (year: number, indexOrId: number | string): Promise<CashFlowManagementData> => {
    return apiClient.delete<CashFlowManagementData>(`/cash-flow-management/year/${year}/cf-employees/${indexOrId}`);
  },

  // 모든 연도 목록 조회
  getAllYears: (): Promise<number[]> => {
    return apiClient.get<number[]>('/cash-flow-management/years');
  },
};